<template>
	<div class="datepicker-wrap" :class="has_error?'errorous':'has_error'">
		<el-date-picker
					v-model="current_date"
					type="date"
          :clearable="false"
					:placeholder="placeholder">
			</el-date-picker>
			<label v-if="show_floating_label" :class="current_date==''?'':'risen'">{{ placeholder }}</label>
	</div>
</template>
<script>
  import moment from 'moment'
	export default {
		name: "SimplementDateInput",
		props: {
    value: {

    },
    type: {
      type: String,
      default: "normal",
    },
    placeholder: {
      type: String,
    },
    notFound: {
      type: String,
    },
    has_error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    show_floating_label: {
      type: Boolean,
      default: true
    }
  },
		data(){
			return {
				current_date:'',
			}
		},
		mounted() {
    this.current_date = this.value
  },
		methods:{
			change() {
        if(this.current_date!=='')
          this.$emit('input', moment(this.current_date).format('Y-M-D'))
        else
          this.$emit('input', '')
      }
		},	
  watch: {
    value(){
      this.current_date = this.value
    },
    current_date(){
      if(this.current_date!=='')
        this.$emit('input', moment(this.current_date).format('Y-M-D'))
      else
        this.$emit('input', '')
    }
  },
	}
</script>
<style scoped>
	@import url(./assets/basic.css);
	input.form-control{
		border-radius: var(--border-radius);
		background: rgba(238, 238, 238, 0.93);
		border: none;
		height: 56px;
	}
	input.form-control::placeholder{
		color: #8D8D8DEE;
		font-size: 14px;
	}
	/* input + label{
		font-size: 10px;
		margin-top: -.5em;
		position: absolute;
		margin-top: -3.25rem;
		position: absolute;
		margin-left: 1.5em;
		opacity: .4;
		transition: all 0.5s;
	} */
	input:placeholder-shown + label{
		opacity: 0;
		font-size: 14px;
		margin-top: -2.5rem;
		margin-left: 1.125em;
		transition: all 0.5s;
		opacity: 0;
	}
	input{
		padding-top: 1rem;
		transition: all .5s;
	}
	input:placeholder-shown{
		padding-top: .5rem;
	}
	input.form-control:focus{
		box-shadow: none !important;
		border: 2px solid var(--neutral-50, rgba(141, 141, 141, 0.93));
	}
</style>
<style>
	.el-input__inner{
		border-radius: 8px !important;
		background: rgba(238, 238, 238, 0.93) !important;
		border: none !important;
		height: 56px !important;
	}
	.el-date-editor.el-input{
		width: 100% !important;
	}
</style>
<style lang="less">
.datepicker-wrap {
  display: 	block;
  position: relative;
}

.datepicker-wrap input.el-input__inner:placeholder-shown{
  padding-top: 0;
  font-size: 14px;
}
</style>

<style scoped>
label{
	opacity: 0;
	font-size: 14px;
	margin-top: -2.5rem;
	margin-left: 1.125em;
	transition: all 0.5s;
	opacity: 0;
  position: absolute;
}
  label.risen{
	font-size: 10px;
	margin-top: -.5em;
	position: absolute;
	margin-top: -3.25rem;
	position: absolute;
	margin-left: 1.5em;
	opacity: .4;
  left: 0;
  top: 4px;
  margin-top: 0;
	transition: all 0.5s;
}


</style>
<style>
	.errorous .el-input--prefix .el-input__inner{
		border-bottom-left-radius: 0 !important;
		border-bottom-right-radius: 0 !important;
		border-bottom: 2px solid var(--error) !important;
	}
	.errorous .el-input--prefix .el-input__inner::placeholder{
		color: var(--error) !important;
	}
	.errorous .el-input--prefix + label{
		opacity: 0 !important;
	}
	.errorous .el-input--prefix + label.risen{
		opacity: 1 !important;
	}
</style>